export const LOGIN = '/login';
export const DASHBOARD_REDIRECT = '/dashboard-redirect';
export const WELCOME_BACK = '/first-loan/welcome-back';
export const WELCOME_BACK_NEW = '/first-loan/welcome-back/new';

export const CONTINUE_AFFILIATE = '/continue/affiliate';
export const AFFILIATE = '/affiliate/:provider';

export const INTRO_START_APP = '/first-loan/start-app';
export const INTRO = '/first-loan/start';
export const INTRO_2 = '/first-loan';

export const PERSONAL_DETAILS = '/first-loan/personal-details';
export const PERSONAL_DETAILS_CONTINUE =
  '/first-loan/personal-details/continue';
export const PHONE_VERIFICATION = '/first-loan/phone-verification';
export const PHONE_CHANGE = '/first-loan/change-phone';
export const FINANCE = '/first-loan/finance';

export const BANK_ID = '/first-loan/bank-id';
export const BANK_ID_WAIT = '/first-loan/bank-id/wait';
export const BANK_ID_CONFIRM = '/first-loan/bank-id/confirm';
export const BANK_ID_ACCOUNT_SELECTION =
  '/first-loan/bank-id/account-selection';
export const BANK_ID_ERROR = '/first-loan/bank-id/error';

export const PSD2_BANKS = '/first-loan/psd';
export const PSD2_GUIDE = '/first-loan/psd/helper';
export const PSD2_CONSENTS = '/first-loan/psd/consent';
export const PSD2_BANK_ACCOUNT_SELECT = '/first-loan/psd/select-account';
export const PSD2_RECEIVING = '/first-loan/psd/receiving';
export const PSD2_VERIFIED = '/first-loan/psd/verified';
export const PSD2_ERROR = '/first-loan/psd/error';
export const DOCUMENT_UPLOAD_LATER = '/first-loan/document-upload/send-later';
export const ADJUST_INCOME = '/first-loan/adjust-income';

export const OFFLINE_TOKEN = '/offline-identification/:token';
export const OFFLINE_PSD2_BANKS = '/psd/offline/select-bank';
export const OFFLINE_PSD2_GUIDE = '/psd/offline/helper';
export const OFFLINE_PSD2_CONSENTS = '/psd/offline/consent';
export const OFFLINE_PSD2_BANK_ACCOUNT_SELECT = '/psd/offline/select-account';
export const OFFLINE_PSD2_RECEIVING = '/psd/offline/receiving';
export const OFFLINE_PSD2_VERIFIED = '/psd/offline/result';
export const OFFLINE_PSD2_ERROR = '/psd/offline/error';

export const MANUAL_PSD2_BANKS = '/first-loan/manual/psd';
export const MANUAL_PSD2_GUIDE = '/first-loan/manual/psd/helper';
export const MANUAL_PSD2_CONSENTS = '/first-loan/manual/psd/consent';

export const WAITING = '/first-loan/waiting';
export const REJECTED_OFFER = '/first-loan/rejected';
export const MANUAL_REVIEW = '/first-loan/manual-review';
export const PENDING = '/first-loan/pending';
export const UPSALE = '/first-loan/upsale';
export const UPSALE_CHANGE_AMOUNT = '/first-loan/upsale/offer';
export const DOWNSALE = '/first-loan/downsale';
export const CONSENT = '/first-loan/consents';
export const APPROVED = '/first-loan/approved';

export const MANUAL_OCR = '/first-loan/manual/ocr';
export const MANUAL_UPLOAD_ID = '/first-loan/manual/upload-id';
export const INCOME_PROOF = '/first-loan/manual/income-proof';

export const MANUAL_IDENTIFICATION = '/first-loan/identification/manual';
export const OCR_RESULTS = '/first-loan/manual/ocr/confirm';
export const SIGN_AGREEMENT = '/first-loan/sign-agreement';

export const LEGACY_LOGIN_ONE_TIME_TOKEN_LOGIN = '/one-time-token-login';
